import { createContext } from 'react';
import { Listing, ListingEnquiry } from 'models/Listing';
import { DropzoneFile } from 'components/Dropzone/utils';
import { Lead, LeadStages, SoftSignalPayload } from 'models/Lead';
import utils from 'utils';
import { DealRoom } from 'models/DealRoom';
import { NDA_STATUSES, NdaStatus } from 'models/Nda';
import { NativeNdaProps, UpdateLeadNdaProps } from 'hooks/useNdaStatus';

type LeadContextProps = {
  leadId: string;
  listing: Partial<Listing>;
  enquiry: Partial<ListingEnquiry>;
  nbio?: DropzoneFile;
  buyerStep: LeadStages;
  signingStatus: NdaStatus;
  envelopeId?: string;
  signedDate?: Date;
  rejectionReason?: string;
  isOfferRejected: boolean;
  isOfferAccepted: boolean;
  sessionId: string;
  withdrawnInterest?: boolean;
  dealRoom?: Partial<DealRoom>;
  canAccessDataRoom?: boolean;
  confirmedInterest?: boolean;
  manuallySetNDAStatus?: boolean;
  nativeNdaProps?: NativeNdaProps;
  unreadMessagesCount?: number;
  isWaitingForWebhook: boolean;
  pulseCheckActive?: boolean;
  isUndoAvailableForCheckPulse: boolean;
  isConfirmingInterestInProgress: boolean;
  updateLead: (lead: Lead) => void;
  updateNdaProps: (leadNdaProps: UpdateLeadNdaProps) => void;
  updateUnreadMessagesCount: (value: number) => void;
  onUndoCheckPulse: () => void;
  onSubmitCheckPulse: (
    data: SoftSignalPayload,
    isSkipPressed?: any,
  ) => Promise<void>;
};

export default createContext<LeadContextProps>({
  listing: null,
  enquiry: null,
  buyerStep: null,
  signingStatus: NDA_STATUSES.NOT_SENT,
  envelopeId: '',
  signedDate: null,
  leadId: '',
  rejectionReason: '',
  isOfferRejected: false,
  isOfferAccepted: false,
  sessionId: '',
  withdrawnInterest: false,
  dealRoom: null,
  nbio: null,
  canAccessDataRoom: false,
  confirmedInterest: false,
  manuallySetNDAStatus: false,
  unreadMessagesCount: 0,
  isWaitingForWebhook: false,
  pulseCheckActive: false,
  isUndoAvailableForCheckPulse: false,
  isConfirmingInterestInProgress: false,
  updateLead: utils.noop,
  updateNdaProps: utils.noop,
  updateUnreadMessagesCount: utils.noop,
  onUndoCheckPulse: utils.noop,
  onSubmitCheckPulse: utils.noop,
});
